import { render, staticRenderFns } from "./workOrrestDetail.vue?vue&type=template&id=709f16ee&scoped=true&"
import script from "./workOrrestDetail.vue?vue&type=script&lang=js&"
export * from "./workOrrestDetail.vue?vue&type=script&lang=js&"
import style0 from "./workOrrestDetail.vue?vue&type=style&index=0&id=709f16ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f16ee",
  null
  
)

export default component.exports